import React from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";

import PageLayout from "@/components/PageLayout";

const POSTS = [
  { title: "Introducing QNNEAL: Quantum-Enhanced AI Optimization for Everyone", date: "April 1, 2026", category: "Product", excerpt: "Today we are excited to announce the public launch of QNNEAL \u2014 the first platform to bring quantum annealing optimization to multi-provider AI workflows. Learn how our technology reduces AI costs by up to 70% while improving performance." },
  { title: "How Quantum Annealing Solves the Multi-Provider Routing Problem", date: "March 25, 2026", category: "Technology", excerpt: "Multi-provider AI routing is fundamentally a combinatorial optimization problem. In this deep dive, we explain how quantum annealing finds near-optimal solutions in milliseconds \u2014 and why classical approaches fall short at scale." },
  { title: "QNNEAL\u2019s Exclusive Access Program: What to Expect", date: "March 18, 2026", category: "Announcements", excerpt: "We are opening our doors to a select group of enterprises, research institutions, and government agencies. Here is what the Exclusive Access Program includes, how to apply, and what early participants are already achieving." },
  { title: "Building Agentic AI Pipelines That Optimize Themselves", date: "March 10, 2026", category: "Engineering", excerpt: "Traditional AI pipelines are static \u2014 you define the steps, the models, and the parameters. QNNEAL\u2019s agentic orchestration layer changes that. Learn how our autonomous agents continuously re-optimize your workflows based on real-time performance data." },
];

const TAG_COLORS = { Product: "bg-cyan-500/15 text-cyan-400", Technology: "bg-violet-500/15 text-violet-400", Announcements: "bg-amber-500/15 text-amber-400", Engineering: "bg-emerald-500/15 text-emerald-400" };

export default function BlogPage() {
  return (
    <PageLayout>
      <div className="max-w-5xl mx-auto px-6 py-16">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <h1 className="text-4xl sm:text-5xl font-bold mb-4" data-testid="blog-heading">QNNEAL Blog</h1>
          <p className="text-lg text-[var(--qn-foreground-muted)] mb-12">Insights on quantum computing, agentic AI, and the future of multi-provider optimization.</p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {POSTS.map((p, i) => (
            <motion.article
              key={i}
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 * i }}
              className="p-6 rounded-xl border border-[var(--qn-border)] bg-[var(--qn-surface)] flex flex-col"
              data-testid={`blog-card-${i}`}
            >
              <div className="flex items-center gap-3 mb-3">
                <span className={`text-xs font-medium px-2.5 py-0.5 rounded-full ${TAG_COLORS[p.category] || "bg-gray-500/15 text-gray-400"}`}>{p.category}</span>
                <span className="text-xs text-[var(--qn-foreground-subtle)]">{p.date}</span>
              </div>
              <h2 className="text-base font-semibold mb-2 leading-snug">{p.title}</h2>
              <p className="text-sm text-[var(--qn-foreground-muted)] leading-relaxed flex-1">{p.excerpt}</p>
              <button
                className="mt-4 text-sm font-medium text-[var(--qn-primary)] hover:underline self-start"
                onClick={() => toast.info("Full article coming soon")}
                data-testid={`blog-read-more-${i}`}
              >
                Read More &rarr;
              </button>
            </motion.article>
          ))}
        </div>
      </div>
    </PageLayout>
  );
}
